import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import ValueProp from "@/components/landing/ValueProp";
import Services from "@/components/landing/Services";
import HowItWorks from "@/components/landing/HowItWorks";
import Trust from "@/components/landing/Trust";
import InquiryForm from "@/components/landing/InquiryForm";
import Footer from "@/components/landing/Footer";
import ConciergeChat from "@/components/landing/ConciergeChat";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-background text-foreground font-body">
      <Header />
      <Hero />
      <ValueProp />
      <Services />
      <HowItWorks />
      <Trust />
      <InquiryForm />
      <Footer />
      <ConciergeChat />
    </main>
  );
};

export default Landing;
